import { task, rawTimeout } from 'ember-concurrency';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { isTesting, macroCondition } from '@embroider/macros';

export default class AppReloader extends Component {
  @service eflexAjax;

  constructor(owner, args) {
    super(owner, args);
    this.checkWebservice.perform();
  }

  checkWebservice = task(async () => {
    const interval = (this.args.checkInterval ?? 1) * 1000;
    let isSuccessful = false;

    while (!isSuccessful) {
      try {
        await rawTimeout(interval);
        await this.eflexAjax.get.perform('health');
        isSuccessful = true;
      } catch {
        if (macroCondition(!isTesting())) {
          console.error('webservice not available yet');
        }
      }
    }

    this.args.reload();
  });
}
